import { Component, Input } from '@angular/core';

// Read-only list of a checklist action's items - for places that only show what an action will contain
// (template book preview, project create's task list) rather than letting anyone tick items off.
@Component({
  selector: 'app-checklist-items-preview',
  templateUrl: './checklist-items-preview.component.html',
  styleUrls: ['./checklist-items-preview.component.scss'],
})
export class ChecklistItemsPreviewComponent {
  @Input() step: any;

  get items(): any[] {
    let data = this.step?.data;
    // A step straight from the API only has its data as a JSON string in steps_data
    if (!data && this.step?.steps_data?.[0]?.step_data) {
      try { data = JSON.parse(this.step.steps_data[0].step_data); } catch { data = null; }
    }
    return Array.isArray(data?.items) ? data.items : [];
  }
}
